import { Link } from 'react-router-dom';
import { Group, Text, Anchor } from '@mantine/core';
import { DataTable, DataTableColumn } from 'mantine-datatable';
import { format } from 'date-fns';
import { MessageTemplate } from '#/components/ui/messages/model';
import { MessageStateBadge } from '#/components/ui/messages';
import { ComponentProps } from 'react';
import {
  MessageCategoryText,
  MessageSendingTargetText,
} from '../components/ui';

const columns: DataTableColumn<MessageTemplate>[] = [
  {
    title: '訊息分類',
    accessor: 'messageCategoryKey',
    titleStyle: { color: 'gray', fontWeight: 'normal' },
    width: '14%',
    render: ({ messageCategory }) => {
      return (
        <Text size="sm">
          <MessageCategoryText value={messageCategory} />
        </Text>
      );
    },
  },
  {
    title: '訊息標題',
    accessor: 'title',
    titleStyle: { color: 'gray', fontWeight: 'normal' },
    width: '30%',
    render: ({ id, title }) => (
      <Anchor component={Link} to={`/messages/${id}`}>
        <Text size="sm">{title}</Text>
      </Anchor>
    ),
  },
  {
    title: '發送狀態',
    accessor: 'status',
    titleStyle: { color: 'gray', fontWeight: 'normal' },
    width: '10%',
    render: ({ state }) => {
      return <MessageStateBadge state={state} />;
    },
  },
  {
    title: '通知方式',
    accessor: 'notiMethod',
    titleStyle: { color: 'gray', fontWeight: 'normal' },
    width: '10%',
    render: ({ notificationSettings }) => {
      return notificationSettings.notification.push_enabled ? (
        <Text size="sm" c="dimmed" fw={500}>
          推播
        </Text>
      ) : (
        <Text size="sm" c="dimmed">
          無
        </Text>
      );
    },
  },
  {
    title: '發送對象 / 人數',
    accessor: 'targetLabel',
    titleStyle: { color: 'gray', fontWeight: 'normal' },
    width: '22%',
    render: ({ segment, segmentSnapshot, id, state }) => {
      return (
        <Group gap="xs">
          <MessageSendingTargetText
            segment={segment}
            segmentSnapshot={segmentSnapshot}
            templateId={id}
            state={state}
          />
        </Group>
      );
    },
  },
  {
    title: '發送時間',
    accessor: 'scheduleAt',
    titleStyle: { color: 'gray', fontWeight: 'normal' },
    width: '14%',
    render: ({ scheduleAt }) =>
      scheduleAt ? format(new Date(scheduleAt), 'yyyy-MM-dd HH:mm:ss') : '-',
  },
];

type MessageListPageProps = Required<
  Pick<
    ComponentProps<typeof DataTable>,
    | 'onPageChange'
    | 'fetching'
    | 'totalRecords'
    | 'recordsPerPage'
    | 'fetching'
    | 'page'
  >
>;

export const MessageTemplateList = (
  props: MessageListPageProps & {
    records: MessageTemplate[];
    total: number;
  },
) => {
  console.log({ props });

  return (
    <>
      <DataTable
        idAccessor="id"
        highlightOnHover
        minHeight={400}
        columns={columns}
        paginationText={({
          from,
          to,
          totalRecords,
        }: {
          from: number;
          to: number;
          totalRecords: number;
        }) => {
          return `顯示 ${from} - ${to} 筆訊息資料，共 ${totalRecords} 筆`;
        }}
        verticalSpacing="sm"
        noRecordsText="沒有符合條件的訊息"
        withTableBorder={false}
        {...props}
      />
    </>
  );
};
